import { global } from ":shared/app";
import type { UserRequests } from "../../SHARED/_model";

export interface Put {
  props: {
    team_name: string;
    track: string;
    thumbnail: FileList;
    brief: string;
  };
  returns: UserRequests;
}

const endpoint = `/teaming/update-team-info`;
export default {
  async put(props: Put["props"]): Promise<Put["returns"]> {
    const formData = new FormData();
    formData.set("team_name", props.team_name);
    formData.set("track", props.track);
    if (props.brief != undefined) {
      formData.set("brief", props.brief);
    }
    if (props.thumbnail != undefined) {
      formData.set("thumbnail", props.thumbnail[0]);
    }
    return global.api
      .putAuth(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        return res.data;
      });
  },
};
